import styled, { keyframes } from 'styled-components';
import { colors } from 'styles/colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ldsRing = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div<{ size?: 'small' }>`
  color: ${colors.icon['white-0']};
  display: inline-block;
  position: relative;
  ${({ size }) => (size === 'small' ? `
    width: 14px;
    height: 14px;
    transform: scale(0.175);
    transform-origin: top left;
  ` : `
    width: 80px;
    height: 80px;
  `)}

  &, & > div {
    box-sizing: border-box;
  }

  & > div {
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid currentColor;
    border-radius: 50%;
    animation: ${ldsRing} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
  }

  & > div:nth-child(1) {
    animation-delay: -0.45s;
  }

  & > div:nth-child(2) {
    animation-delay: -0.3s;
  }

  & > div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;
